import { Mediator, app, ojs } from "modular-openscriptjs";
import { empty, inform, eParse } from "../helpers";
import { STRINGS, api } from "../declarations";
import { $e } from "../ojs.events";


export default class HashtagLocationMediator extends Mediator {
	$$hashtag = {
		location: {
			needs: {
				storage: (ed, event) => this.storeLocations(ed, event),
			},
		},
	};

	async storeLocations(ed, event) {
		let { message } = eParse(ed);

		if (empty(message.hashtags)) {
			inform("Hashtags cannot empty", STRINGS.ERROR);
			return this.send($e.hashtag.location.has.storageError, ed);
		}

		if (empty(message.locations)) {
			inform("Locations cannot empty", STRINGS.ERROR);
			return this.send($e.hashtag.location.has.storageError, ed);
		}

		let res = await api.put("hashtags/locations", message);

		if (!res) {
			return this.send($e.hashtag.location.has.storageError, ed);
		}

		inform("Hashtags Locations Saved", STRINGS.SUCCESS);
		return this.send($e.hashtag.location.stored, ed);
	}
}

ojs(HashtagLocationMediator);
